import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import TrailingSlashRedirect from "../../components/TrailingSlashRedirect";
import { MessagesInterceptor } from "../../helpers/socketInterceptors/MessagesInterceptor";
import { usePostHogIdentify } from "../../hooks/usePostHogIdentify";
import useLanguageSync from "../../hooks/global/useLanguageSync";

const MainLayout = () => {
  usePostHogIdentify();
  useLanguageSync();

  return (
    <Layout className="theme-background-color">
      <TrailingSlashRedirect />
      <Outlet />
      <MessagesInterceptor />
    </Layout>
  );
};

export default MainLayout;
